module.exports = __webpack_public_path__ + "img/expert_avatar.66efde2.png";